var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 36,
    viewBox: "0 0 147 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 147,
    height: 36,
    fill: "#4A2E1A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 36V35.999C0.113627 35.9997 0.227609 36 0.341947 36H0Z",
    fill: "#352011"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.986 36C128.662 35.9954 119.497 26.9977 110.333 18C101.166 9 91.9995 -2.05286e-06 73.666 0C55.3313 0 46.1645 9.00123 36.9984 18.0018C27.8335 27.0012 18.6692 36 0.341947 36L146.986 36Z",
    fill: "#352011"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecor);
export default __webpack_public_path__ + "static/media/decor.2b6933b82c991086a41041ed5c8a7fc0.svg";
export { ForwardRef as ReactComponent };